import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Table, TableModule } from 'primeng/table';

@Component({
    selector: 'app-column-filter',
    standalone: true,
    imports: [CommonModule, TableModule],
    templateUrl: './column-filter.component.html',
    styleUrl: './column-filter.component.scss'
})
export class ColumnFilterComponent {
    @Input({ required: true }) table!: Table;
    @Input({ required: true }) field!: string;

    @Input() type: 'text' | 'numeric' | 'date' | 'boolean' = 'text';
    @Input() display: 'menu' | 'row' = 'menu';

    @Input() showMenu: boolean = true;
    @Input() hideOnClear: boolean = false;
    @Input() placeholder?: string;
    @Input() ariaLabel?: string;

    get resolvedDisplay(): 'menu' | 'row' {
        if (this.showMenu === false) return 'row';
        return this.display;
    }

    isColumnFiltered(): boolean {
        const filters: any = this.table?.filters;
        if (!filters) return false;

        const meta = filters[this.field];
        if (!meta) return false;

        if (Array.isArray(meta)) {
            return meta.some((m) => {
                const value = (m as any)?.value;
                return value !== null && value !== undefined && `${value}`.trim().length > 0;
            });
        }

        const value = (meta as any)?.value;
        return value !== null && value !== undefined && `${value}`.trim().length > 0;
    }
}
